(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3115],{

/***/ 31353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports seoKeys, emptySeo */
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var seoKeys = {// NotFound: "notFound",
  // Homepage: "homePage",
  // firstHand: `firstHand_`, // use with car id. example: {firstHand_122123}
  // zeroKm: "zeroKm_", // use with car slug. example: {zeroKm_14/629/271/2021}
  // leasing: "leasing_", // use with car slug. example: {leasing_14/629/271/2021}
};

for (var key in seoKeys) {
  seoKeys[key] = encodeURIComponent(seoKeys[key].replace(/\/\[.+/, "").replace("/", "").replace(/-/g, " "));
}

var emptySeo = {
  title: " ",
  description: "",
  keywords: ""
};

var SeoMetaData = function SeoMetaData(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: data && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_0__/* .NextSeo */ .PB, {
      title: data.title,
      description: data.description || "",
      additionalMetaTags: [{
        name: "title",
        content: data.title
      }, {
        name: "keywords",
        content: data.keywords
      }, {
        name: "description",
        content: data.description
      }],
      openGraph: {
        title: data.title,
        description: data.description || ""
      }
    })
  });
};

/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(SeoMetaData));

/***/ }),

/***/ 2936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var SvgComponent = function SvgComponent() {
  var w = 31;
  var h = 31;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "back arrow",
    width: w,
    height: h,
    viewBox: "0 0 31 31",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
      "data-name": "Ellipse 6",
      cx: "15.5",
      cy: "15.5",
      r: "15.5",
      fill: "#f7f7f7"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
      "data-name": "Path 603",
      d: "M13.843 20.428a.5.5 0 0 1-.319-.881L18.38 15.5l-4.857-4.046a.5.5 0 1 1 .638-.766l5.316 4.43a.5.5 0 0 1 0 .765l-5.316 4.43a.5.5 0 0 1-.318.115z"
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgComponent);

/***/ }),

/***/ 72300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ sitemap; }
});

// EXTERNAL MODULE: ./common/SeoMetaData.tsx
var SeoMetaData = __webpack_require__(31353);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./common/SiteLinks.tsx + 12 modules
var SiteLinks = __webpack_require__(152);
// EXTERNAL MODULE: ./components/Reusable/Bit/NextLink.tsx
var NextLink = __webpack_require__(16110);
// EXTERNAL MODULE: ./layout/Header.tsx + 8 modules
var Header = __webpack_require__(21282);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
// EXTERNAL MODULE: ./components/Icons/BackIcon.tsx
var BackIcon = __webpack_require__(2936);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/SiteMap/SiteMapPage.tsx












var StyledContainer = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
  displayName: "SiteMapPage__StyledContainer",
  componentId: "sc-1o3ke14-0"
})(["margin-top:80px;height:100%;padding:26px 60px;", "{min-height:600px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledLink = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SiteMapPage__StyledLink",
  componentId: "sc-1o3ke14-1"
})(["display:flex;cursor:pointer;p{margin-right:8px;}:hover{text-decoration:underline;}"]);
var StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "h1"
}).withConfig({
  displayName: "SiteMapPage__StyledTitle",
  componentId: "sc-1o3ke14-2"
})(["text-align:right;margin-top:25px;font-size:50px;", "{font-size:40px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledContentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SiteMapPage__StyledContentContainer",
  componentId: "sc-1o3ke14-3"
})(["margin-top:20px;display:flex;overflow:wrap;"]);
var StyledColumn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SiteMapPage__StyledColumn",
  componentId: "sc-1o3ke14-4"
})(["margin-left:80px;"]);
var StyledLinkText = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "SiteMapPage__StyledLinkText",
  componentId: "sc-1o3ke14-5"
})(["font-size:20px;line-height:24px;padding-bottom:20px;text-align:right;", "{font-size:22px;}:hover{text-decoration:underline;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledColumnTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "h4"
}).withConfig({
  displayName: "SiteMapPage__StyledColumnTitle",
  componentId: "sc-1o3ke14-6"
})(["text-align:right;height:28px;"]);
var StyledList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SiteMapPage__StyledList",
  componentId: "sc-1o3ke14-7"
})(["display:flex;flex-direction:column;flex-wrap:wrap;margin-top:20px;", "{max-height:380px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledLinkList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SiteMapPage__StyledLinkList",
  componentId: "sc-1o3ke14-8"
})(["margin-top:20px;"]);
var StyledListItem = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "SiteMapPage__StyledListItem",
  componentId: "sc-1o3ke14-9"
})(["text-align:right;display:block;margin-left:80px;padding-bottom:20px;font-size:20px;line-height:24px;", "{font-size:22px;}:hover{text-decoration:underline;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledIconBtn = (0,styled_components_browser_esm/* default */.ZP)(IconButton/* default */.Z).withConfig({
  displayName: "SiteMapPage__StyledIconBtn",
  componentId: "sc-1o3ke14-10"
})(["padding:1px;position:relative;bottom:2px;"]);
var StyledListContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SiteMapPage__StyledListContainer",
  componentId: "sc-1o3ke14-11"
})([""]);

var SiteMapPage = function SiteMapPage(_ref) {
  var categories = _ref.categories;
  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Header["default"], {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledLink, {
        onClick: function onClick() {
          return router.back();
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledIconBtn, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(BackIcon/* default */.Z, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
          variant: "body1",
          children: "\u05D7\u05D6\u05E8\u05D4"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTitle, {
        children: "\u05DE\u05E4\u05EA \u05D0\u05EA\u05E8"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledContentContainer, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledColumn, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledColumnTitle, {
            children: "\u05DB\u05DC\u05DC\u05D9"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLinkList, {
            children: SiteLinks/* GeneralLinks.map */.oc.map(function (item, i) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                href: item === null || item === void 0 ? void 0 : item.link,
                openInNewTab: item.blank,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLinkText, {
                  children: item.title
                })
              }, "".concat(item, " + ").concat(i));
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledListContainer, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledColumnTitle, {
            children: "\u05E7\u05D8\u05D2\u05D5\u05E8\u05D9\u05D5\u05EA"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledList, {
            children: categories.map(function (category, j) {
              if ((category === null || category === void 0 ? void 0 : category.name) === "הכי פופולרי") return;
              return /*#__PURE__*/(0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                href: "/category/".concat((category === null || category === void 0 ? void 0 : category.slug) || ""),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledListItem, {
                  children: category.name
                })
              }, "".concat(category).concat(j));
            })
          })]
        })]
      })]
    })]
  });
};

/* harmony default export */ var SiteMap_SiteMapPage = (SiteMapPage);
;// CONCATENATED MODULE: ./src/pages/sitemap.tsx






var SiteMap = function SiteMap(_ref) {
  var categories = _ref.categories;
  var seo = {
    title: "מפת אתר גיפטקארד מקדונלד'ס",
    description: "מפת אתר גיפטקארד מקדונלד'ס",
    keywords: "מפת אתר, sitemap, מפה, מפת האתר"
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SeoMetaData/* default */.ZP, {
      data: seo
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SiteMap_SiteMapPage, {
      categories: categories
    })]
  });
};

var __N_SSG = true;
/* harmony default export */ var sitemap = (SiteMap);

/***/ }),

/***/ 3082:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap",
      function () {
        return __webpack_require__(72300);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2726,3450,2066,9306,3153,1282,9774,2888,179], function() { return __webpack_exec__(3082); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);